import { render, staticRenderFns } from "./EarningsCard.vue?vue&type=template&id=4be95797&scoped=true"
import script from "./EarningsCard.vue?vue&type=script&lang=js"
export * from "./EarningsCard.vue?vue&type=script&lang=js"
import style0 from "./EarningsCard.vue?vue&type=style&index=0&id=4be95797&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be95797",
  null
  
)

export default component.exports